export default __webpack_public_path__ + "static/media/Fansided_logo.32f06292.svg";